import { render } from "./ZenitSaude.vue?vue&type=template&id=130f28bc&scoped=true"
const script = {}

import "./ZenitSaude.vue?vue&type=style&index=0&id=130f28bc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130f28bc"]])

export default __exports__